export const geodisLight = {
  primary: '#3200e6',
  primaryHover: '#212166',
  secondary: '#9D97FF',
  success: '#23AF82',
  error: '#E60050',
  orange: '#F59114',
  yellow: '#F8D24B',
  cyan: '#8DDAF5',
  text: '#404040',
  icon: '#92929D',
  iconRounded: '#E0E0E0',
  background: '#F1F1F5',
  grisClair: '#FAFAFB',
  white: '#FFFFFF',
  magenta: '#CC69A5',
};

export const geodisTheme = {
  light: geodisLight,
};
